/**
 * MIT License
 * name: @mmears/log
 * version: 1.3.0-alpha.2
 * author: mmears-fe
 */

'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var sensors = _interopDefault(require('sa-sdk-javascript'));

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

/**
 * 加密指定的手机号
 * @param account 手机号
 */
function encryptAccount(account) {
    if (!account) {
        return account;
    }
    var phoneReg = /^1[0-9]\d{9}$/;
    if (phoneReg.test(account)) {
        return account.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2');
    }
    return account;
}
/**
 * 格式化
 * @param num
 */
function format(num) {
    if (num >= 10) {
        return String(num);
    }
    else {
        return "0" + num;
    }
}
/**
 * 获取当前时间
 */
function getTime() {
    var time = new Date();
    var y = time.getFullYear(); // getFullYear方法以四位数字返回年份
    var M = time.getMonth() + 1; // getMonth方法从 Date 对象返回月份 (0 ~ 11)，返回结果需要手动加一
    var d = time.getDate(); // getDate方法从 Date 对象返回一个月中的某一天 (1 ~ 31)
    var h = time.getHours(); // getHours方法返回 Date 对象的小时 (0 ~ 23)
    var m = time.getMinutes(); // getMinutes方法返回 Date 对象的分钟 (0 ~ 59)
    var s = time.getSeconds(); // getSeconds方法返回 Date 对象的秒数 (0 ~ 59)
    return (y + '-' + format(M) + '-' + format(d) + ',' + format(h) + ':' + format(m) + ':' + format(s));
}
/**
 * 判断是否Object
 *
 * @name isObject
 * @function
 * @memberOf type
 * @param {any} o 判断对象
 * @return {boolean} 是否Object
 */
function isObject(o) {
    return ((o || false) &&
        (o.constructor === Object || Object.prototype.toString.call(o) === '[object Object]'));
}

var NODE_ENV = process.env.NODE_ENV;
/**
 * 神策数据上报地址
 */
var serverUrlConfig = {
    development: 'https://collector-dev.mmears.com/sa?project=default',
    production: 'https://collector.mmears.com/sa?project=production'
};
var getServerUrl = function (env) {
    var isProduction = false;
    // 配置里的 env 变量, 优先级高
    if (env) {
        if (env === 'production') {
            isProduction = true;
        }
    }
    else {
        isProduction = NODE_ENV === 'production';
    }
    if (isProduction) {
        return serverUrlConfig.production;
    }
    return serverUrlConfig.development;
};

var NODE_ENV$1 = process.env.NODE_ENV;
var DEFAULT_EVENT_NAME = 'web_log';
/**
 * 为了防止多次初始化
 */
var isInit = false;
/**
 * 是否是开发环境
 */
var isDevelopment = NODE_ENV$1 === 'development';
/**
 * 前端日志类
 */
var Logger = /** @class */ (function () {
    function Logger(config) {
        this.config = __assign({}, config, { eventName: config.eventName || 'web_log' });
        this.init();
    }
    /**
     * 在登录和注册成功后，调用方法来标识真实用户
     * @param userId 用户登录后的id
     */
    Logger.prototype.login = function (userId) {
        // 检查日志是否被禁止, 只有本地开发环境 才可以 禁用日志上报
        if (this.checkDisabled()) {
            return;
        }
        try {
            sensors.login(userId);
        }
        catch (error) {
            console.error('monitor.login', error);
        }
    };
    /**
     * 使用 logout 切换到之前的匿名id
     */
    Logger.prototype.logout = function () {
        // 检查日志是否被禁止, 只有本地开发环境 才可以 禁用日志上报
        if (this.checkDisabled()) {
            return;
        }
        try {
            sensors.logout(true);
        }
        catch (error) {
            console.error('monitor.logout', error);
        }
    };
    /**
     * 记录埋点日志
     * @param data 日志信息 或者 日志对象
     */
    Logger.prototype.info = function (data) {
        // 检查日志是否被禁止, 只有本地开发环境 才可以 禁用日志上报
        if (this.checkDisabled()) {
            return;
        }
        try {
            var logData = this.handleDataBeforeReport(data);
            logData.errCode = 'OK';
            this.log(logData);
        }
        catch (error) {
            console.error('logger.info', error);
        }
    };
    /**
     * 记录错误日志
     * @param data 日志信息 或者 日志对象
     */
    Logger.prototype.error = function (data) {
        // 检查日志是否被禁止, 只有本地开发环境 才可以 禁用日志上报
        if (this.checkDisabled()) {
            return;
        }
        try {
            var logData = this.handleDataBeforeReport(data);
            logData.errCode = logData.errCode || 'ERROR';
            this.log(logData);
        }
        catch (error) {
            console.error('logger.error', error);
        }
    };
    /**
     * 记录致命错误
     * @param data
     */
    Logger.prototype.fatal = function (data) {
        // 检查日志是否被禁止, 只有本地开发环境 才可以 禁用日志上报
        if (this.checkDisabled()) {
            return;
        }
        try {
            var logData = this.handleDataBeforeReport(data);
            logData.errCode = 'FATAL';
            this.log(logData);
        }
        catch (error) {
            console.error('logger.error', error);
        }
    };
    /**
     * 记录日志
     * @param data
     */
    Logger.prototype.log = function (data) {
        // 支持自定义 日志的事件名称
        var eventName = data.eventName || this.config.eventName || DEFAULT_EVENT_NAME;
        // 用户账号
        data.account = data.account || (this.config.getAccount && this.config.getAccount()) || '';
        data.account = encryptAccount(data.account); // 加密手机号
        // 浏览器信息
        data.userAgent = window.navigator.userAgent;
        // 当前url
        data.href = window.location.href;
        // 时间
        data.createTime = getTime();
        // 本地时间戳
        data.localTime = Date.now();
        // 记录日志
        sensors.track(eventName, data);
    };
    /**
     * 初始化
     */
    Logger.prototype.init = function () {
        if (isInit) {
            return;
        }
        isInit = true;
        // 检查日志是否被禁止, 只有本地开发环境 才可以 禁用日志上报
        if (this.checkDisabled()) {
            return;
        }
        // 获取上报地址
        var serverUrl = getServerUrl(this.config.env);
        // 是否显示控制台日志,  生产环境关闭, 其他环境可以自己配置
        var showLog = NODE_ENV$1 !== 'production' ? !!this.config.showLog : false;
        var clickmap = this.config.webClick === 'on' ? 'default' : 'not_collect';
        // tslint:disable-next-line:variable-name
        var scroll_notice_map = this.config.webStay === 'on' ? 'default' : 'not_collect';
        /** 初始化神策配置信息 */
        try {
            // 神策初始化
            sensors.init({
                server_url: serverUrl,
                heatmap: {
                    // 是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
                    clickmap: clickmap,
                    // 是否开启触达注意力图，默认 default 表示开启，自动采集 $WebStay 事件，可以设置 'not_collect' 表示关闭
                    scroll_notice_map: scroll_notice_map
                },
                // 是否显示控制台日志
                show_log: showLog
            });
            if (this.config.autoTrack) {
                // 默认事件追踪
                sensors.quick('autoTrack');
            }
        }
        catch (error) {
            console.error('monitor.init', error);
        }
        /** 设置window的异常上报 */
        this.setWindowOnError();
    };
    /**
     * 设置window的异常上报
     */
    Logger.prototype.setWindowOnError = function () {
        // tslint:disable-next-line
        var that = this;
        /**
         * 保存之前的 onerror
         */
        var oldError = window.onerror;
        /**
         * 记录错误, 并上报
         * @param columnNo 最后两个参数有些部分浏览器拿不到
         * @param error 最后两个参数有些部分浏览器拿不到
         */
        function handleError() {
            var args = arguments;
            var params = JSON.stringify(args);
            if (oldError) {
                oldError.apply(window, [params]);
            }
            // @ts-ignore
            var msg = args[0], fileUrl = args[1], lineNo = args[2], columnNo = args[3], error = args[4];
            var stack = null;
            if (error && error.stack) {
                stack = error.stack;
            }
            var errorInfo = {
                msg: msg || null,
                fileUrl: fileUrl || null,
                lineNo: lineNo || null,
                columnNo: columnNo || null,
                stack: stack
            };
            // 上报日志
            that.error({
                errCode: 'window.onerror',
                eventCode: '',
                account: 'window.onerror',
                message: JSON.stringify(errorInfo)
            });
        }
        window.onerror = handleError;
    };
    /**
     * 检查日志是否被禁止, 只有本地开发环境 才可以 禁用日志上报
     */
    Logger.prototype.checkDisabled = function () {
        // 如果是本地开发环境, 并且日志上报状态 不等于 开启
        if (isDevelopment && this.config.localLogStatus !== 'on') {
            return true;
        }
        return false;
    };
    /**
     * 处理上报前的数据
     * @param data
     */
    Logger.prototype.handleDataBeforeReport = function (data) {
        var logData;
        if (typeof data === 'string') {
            logData = {
                eventCode: '',
                message: data
            };
        }
        else {
            logData = data;
        }
        try {
            if (this.config.beforeHandle && typeof this.config.beforeHandle === 'function') {
                var result = this.config.beforeHandle(logData);
                if (isObject(result)) {
                    return result;
                }
                return logData;
            }
            return logData;
        }
        catch (e) {
            return logData;
        }
    };
    return Logger;
}());

/**
 * 日志工厂函数, 返回一个日志类实例
 * @param config 日志配置选项
 */
function logFactory(config) {
    return new Logger(config);
}

exports.Logger = Logger;
exports.default = logFactory;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@mmears/log/dist/index.js
// module id = YN04
// module chunks = 1